import { Directive, ElementRef, HostListener, Inject, Renderer2 } from '@angular/core';
@Directive({
  selector: '[ipmSideTabChangeClass]'
})
export class SideTabMobileChangeClassDirective {
  constructor(private relRef: ElementRef) { }

  @HostListener('window:scroll', ['$event'])

  onWindowScroll(e:any) {
    let element: any = document.getElementById("ipm-left-section");
    const pageYOffset:any = window.pageYOffset;
    if (element) {
      if (pageYOffset > element.offsetTop) {
        element.classList.add('fixed-top-section');
      } else {
        element.classList.remove('fixed-top-section');
      }
    }
  }

}
